(function ($) {
    'use strict';
    $.widget("fd.control_checkbox", {
        options: {
            parentid: null,
            callback: function () { },
            group: null
        },
        _create: function () {
            if (!this.options.parentid) {
                this.options.parentid = this.element.closest('[data-fd-parentid]').data('fd-parentid');
            }
            this.element.removeClass('d-none').removeAttr('data-fouc').uniform();
            this.element.val(this.element[0].checked ? 'true' : 'false');
            this._setEvents();
        },
        _handleSubmit: function (event) {
            const self = event.data;
            // Fix to post true/false instead of on/off for c# models.
            self.element.val(self.element[0].checked ? 'true' : 'false');
            // Fix for radio groups that have different name's OptionList[0].Selected
            if (self.element.attr('type') === 'radio' && self.options.group) {
                $.uniform.update(self.element.closest('form').find('[data-fd-group="' + self.options.group + '"]').not(self.element).prop('checked', false));
            }
            self.options.callback.call(self, { parentid: self.options.parentid, value: self.element[0].checked }, event);
        },
        _setEvents: function () {
            this.element.off('change.fdcontrol').on('change.fdcontrol', null, this, this._handleSubmit);
        },
        _setOption: function (key, value) {
            this.options[key] = value;
        },
        refresh: function () {
            $.uniform.update(this.element);
        },
        update: function (value) {
            const checked = this.element.is(":checked");
            if (checked !== value) {
                this.element.click();
            } 
        }
    });
}(jQuery));